import { useOutletContext, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Building2, Network, ShieldCheck } from "lucide-react";

export default function PortalHome() {
  const { me } = useOutletContext();
  const roleLabel = me.user.account_type === "client_admin" ? "Client admin" : "Member";

  return (
    <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-testid="portal-home">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-800/70">Welcome</div>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-forest-deep sm:text-4xl" data-testid="portal-home-org">
          {me.org.legal_name}
        </h1>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-900/5 px-3 py-1.5 text-xs font-semibold text-forest-deep" data-testid="portal-home-role">
            <ShieldCheck className="h-3.5 w-3.5 text-emerald-700" />
            {roleLabel}
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-900/5 px-3 py-1.5 text-xs font-semibold text-forest-deep">
            <Building2 className="h-3.5 w-3.5 text-emerald-700" />
            {me.org.plan_tier === "pro" ? "Pro plan" : "Free plan"} · {me.seats.used} of {me.seats.limit} seats
          </span>
        </div>
      </motion.div>

      <div className="noise-overlay relative mt-10 overflow-hidden rounded-3xl bg-forest-deep p-8 sm:p-12" data-testid="portal-home-placeholder">
        <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-emerald-500/10 blur-[80px]" />
        <div className="relative">
          <div className="flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-400">
            <Network className="h-4 w-4" /> First module live
          </div>
          <h2 className="mt-3 max-w-2xl font-display text-2xl font-bold text-[#FBF9F4] sm:text-3xl">
            Your supply-chain compliance board is ready.
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-emerald-100/70">
            Add everyone {me.org.legal_name} buys from and sells to, then track CPCB registration and MSME status from one dashboard.
          </p>
          <Link to="/portal/network" data-testid="portal-home-network-cta" className="mt-6 inline-flex items-center gap-2 rounded-full bg-emerald-400 px-5 py-2.5 font-display text-sm font-bold text-forest-deep transition-colors hover:bg-emerald-300">
            Open network <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </main>
  );
}
